import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import report from '../assets/report.svg';
import AnimatedButton from './AnimatedButton';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function ChartSection() {
  return (
    <ChartSectionStyled id="stats">
      <InnerLayout>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: '0.5' }}
        >
          <div className="chart-container">
            <div className="chart-left">
              <div className="stats">
                <img src={report} alt="" />
              </div>
            </div>
            <div className="chart-right">
              <h2 className="secondary-heading">Help us make the numbers higher</h2>
              <p>
                We have a great variety of features, that make this webapp awesome. You can start creating your personal
                environment and save all of your photos We want you to save your the most precious memories. Start by
                pressing the register button.
              </p>
              <Link to="/login" className="button-content">
                <AnimatedButton name={'Register Now'} />
              </Link>
            </div>
          </div>
        </motion.div>
      </InnerLayout>
    </ChartSectionStyled>
  );
}

const ChartSectionStyled = styled.section`
  .chart-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 1347px) {
      grid-template-columns: repeat(1, 1fr);
    }
    .chart-left {
      justify-content: center;
      align-items: center;
      display: flex;
      .stats {
        width: 90%;
        img {
          margin-top: 1.2rem;
          width: 100%;
          padding: 10px;

          border-radius: 62px;
        }
        .stats-content {
          border: 1px solid var(--border-colour);
          border-radius: 50px;
          margin: 10px;
          background-color: white;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          width: 100%;

          justify-content: space-between;
          @media screen and (max-width: 1347px) {
            grid-template-columns: repeat(1, 1fr);
          }
        }
      }
    }
    .chart-right {
      padding: 2rem;
      @media screen and (max-width: 1347px) {
        padding: 2rem 0;
      }

      p {
        padding: 1.3rem 0;
      }
      .button-content {
        display: flex;
        @media screen and (max-width: 768px) {
          justify-content: center;
        }
      }
    }
  }
`;

export default ChartSection;
